<template>
  <div>
    <div
      class="racing-tool-back"
      @click="racingToolClicked(item)"
    >
      <div class="racing-tool-leftimg" :class="'coloricon' + item.menuTag">
        <i v-if="type === 1" class="icon iconfont" :class="item.icon"></i>
        <i v-else class="icon" :class="item.icon"></i>
      </div>
      <div class="racing-tool-right">
        <div style="font-size: 18px;">{{ item.rightTitle }}</div>
        <div class="racing-tool-desc">{{ item.rightDesc }}</div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    item: {
      type: Object
    },
    index: {
      type: Number
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {

    }
  },
  methods: {
    racingToolClicked (item) {
      if (item.path) {
        this.$router.push(
          {
            path: item.path
          }
        )
      }
    }
  }
}
</script>
